import { render, staticRenderFns } from "./labelTooltip-editor.vue?vue&type=template&id=24837c06&scoped=true&"
import script from "./labelTooltip-editor.vue?vue&type=script&lang=js&"
export * from "./labelTooltip-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24837c06",
  null
  
)

export default component.exports